import React from 'react';
import { Button } from 'antd';
import PersonRow from './PersonRow';
import StageRow from './StageRow';
import type { TSubmitProvider } from '../types';
import s from '../s.module.less';

type Props = {
    people: TSubmitProvider[];
    onBack: () => void;
    onStartListing: () => void;
    onTrack: () => void;
};

// solo 专用：group 的 marketplace offer 走 choose 屏发邀请，不经过这里。
// 这屏不创建 listing，只说明 marketplace 上线要做的三件事，然后把人交给真正的 PPA onboarding。
export default function ListingPreviewScreen({ people, onBack, onStartListing, onTrack }: Props) {
    return (
        <>
            <div className={s.backRow}>
                <Button type="link" onClick={onBack}>
                    Back
                </Button>
            </div>
            <div className={s.eyebrow}>Klarity Marketplace</div>
            <h1 className={s.h1}>Your listing starts here.</h1>
            <p className={s.lead}>
                Here is what setting up your listing involves. It takes a few minutes, and nothing goes live until you
                finish.
            </p>
            <div className={`${s.card} ${s.listCard}`}>
                {people.map((p, i) => (
                    <PersonRow key={p.providerId} person={p} first={i === 0} />
                ))}
                <StageRow
                    num={1}
                    title="Confirm profile details"
                    sub="Review what patients will see."
                    first={people.length === 0}
                />
                <StageRow
                    num={2}
                    title="Add rates and availability"
                    sub="Choose the visits and times you want to offer."
                />
                <StageRow
                    num={3}
                    title="Review fees and listing terms"
                    sub="Complete the required review before the listing goes live."
                    last
                />
            </div>
            <div className={s.actions}>
                <Button type="primary" onClick={onStartListing}>
                    Start my listing
                </Button>
                <Button type="link" onClick={onTrack}>
                    Back to credentialing
                </Button>
            </div>
        </>
    );
}
